import React, {ReactNode} from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import {AlignTextType} from 'types/Fonts'
import {HeadingAppearanceType} from 'types/Typography'
import {SpacingPropsType} from 'types/Layout'
import {ThemeType} from 'types/Theme'

type HeadingPropsType = {
  /** Position of the content */
  align?: AlignTextType
  /** The html tag to be used */
  as?: string
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string
  /** Header content */
  children: ReactNode
  /** Margin bottom size. Only spacing sizes from the theme are accepted. */
  marginBottomSize?: SpacingPropsType
  /** Margin top size. Only spacing sizes from the theme are accepted. */
  marginTopSize?: SpacingPropsType
  /** The header appearance from the theme header options  */
  appearance: HeadingAppearanceType
  /** className to be applied to the component */
  className?: string
}

type StyleProps = {
  theme?: ThemeType
}

const HeadingElement = styled('h2')(
  ({
    theme,
    appearance,
    align,
    marginTopSize,
    marginBottomSize
  }: HeadingPropsType & StyleProps) => css`
    ${theme.typography.heading[appearance]};
    text-align: ${align};
    ${marginBottomSize &&
    `margin-bottom: ${theme.layout.spacing[marginBottomSize]}px;`}
    ${marginTopSize && `margin-top: ${theme.layout.spacing[marginTopSize]}px;`}
  `
)

const Heading = ({
  as,
  appearance,
  align,
  marginTopSize,
  marginBottomSize,
  dataId,
  children,
  className
}: HeadingPropsType) => {
  return (
    <HeadingElement
      as={as}
      data-id={dataId}
      appearance={appearance}
      align={align}
      marginTopSize={marginTopSize}
      marginBottomSize={marginBottomSize}
      className={className}
    >
      {children}
    </HeadingElement>
  )
}

Heading.defaultProps = {
  as: 'h2',
  align: 'left'
}

export default Heading
